/* eslint-disable no-use-before-define */
/* eslint-disable no-debugger */

import { useLazyQuery, useQuery } from "@apollo/client";
import dayGridPlugin from "@fullcalendar/daygrid"; //
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import {
  Alert,
  Badge,
  Col,
  DatePicker,
  Input,
  Popover,
  Radio,
  Row,
  Select,
  Skeleton,
  Spin,
  Switch,
  Tag,
  Tooltip,
  message,
} from "antd";
import dayjs from "dayjs";
import isEmpty from "lodash/isEmpty";
import { capitalize, get, isFunction } from "lodash";
import isUndefined from "lodash/isUndefined";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { formatPhoneNumber } from "react-phone-number-input";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { DownloadOutlined } from "@ant-design/icons";
import { UserContext } from "../../amplify/authenticator-provider";
import { APPOINTMENT_STATUS, APPOINTMENT_STATUS_COLORS } from "../../constant/AppointmentConstant";
import {
  APPOINTMENT_CALENDAR,
  GET_ALL_USERS,
  GET_APPOINTMENT_POPUP_DETAILS,
  GET_COMPANY_WORK_HOURS,
  GET_REMAINING_APPOINTMENT_FORM_DETAILS,
  GET_OPPORTUNITTIES_TYPES,
} from "../../graphql/query";
import useLang from "../../hooks/useLang";
import { Container } from "../../library/basicComponents";
import { colorConfig } from "../../library/colorConfig";
import { AccessPermissionAction, DASHBOARD_DRILL_IN_NOTE } from "../../library/constants";
import { checkAccessPermission, openDialog } from "../../library/helpers";
import {
  convertUtcToLocal,
  firstUpperCaseWordParser,
  getDifferedState,
  parseVehicle,
} from "../../library/utils";
import {
  CALENDAR_VIEW,
  CUSTOM,
  reducerClearDateFilters,
  reducerSetAppointmentCalendarMode,
  reducerSetAppointmentDateMode,
  reducerSetAppointmentDateType,
  reducerSetAppointmentCustomRange,
  reducerSetAppointmentRange,
  reducerSetAppointmentStatus,
  reducerSetAppointmentUserIds,
  reducerSetAppointmentUserMode,
  reducerSetOpportunityTypeId,
  reducerSetAppointmentFilters,
  APPOINTMENT_DATE_MODE,
} from "../../redux/slices/appointmentSlice";
import { getLocationId } from "../../redux/slices/locationSlice";
import CustomButton from "../commonComponents/button";
import UserSelector from "../commonComponents/userSelector";
import EntityFilter, { ENTITY_MODE } from "../commonComponents/EntityFilter";
import OpportunitySourceSelect from "../commonComponents/OpportunitySourceSelect";
import {
  OpportunityTypeIcon,
  getRootOpportunityTypeName,
} from "../../icons/js/OpportunityTypeIcon";
import AppointmentList from "./appointmentList";
import "./calendar.css";
import {
  convertJSONtoCSV,
  downloadCSV,
  getUniqueVehicleOfInterest,
} from "./activityCenter/engagementHelpers";
import { DATE_TIME_FORMATS, getDateRangeFromFilter, isValidYear } from "../../utils/dateTimes";
import { OpportunityTypeCascader } from "./cascaders/OpportunityCascaders";

const utc = require("dayjs/plugin/utc");

dayjs.extend(utc);
// import AppointmentForm from "./appointmentForm";
// import AppointmentList from "./appointmentList";

const MAX_VISIBLE = 4;

// The three standard FullCalendar views exposed by the month/week/day toggle.
// Used to filter out our custom view types from being persisted into calendarMode.
const STANDARD_CALENDAR_VIEWS = ["dayGridMonth", "timeGridWeek", "timeGridDay"];

export const UlWrap = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  & .ant-badge-status {
    width: 100%;
    overflow: hidden;
    font-size: 12px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  & .ant-badge-status-text {
    font-size: 14px;
    background: #00a1c9;
    padding: 10px;
    color: #fff !important;
    border-radius: 12px;
  }
`;

export const LIWrap = styled.li`
  .ant-badge-status-text {
    background: ${props =>
      props.status === "error"
        ? colorConfig.cancelAppointement
        : props.status === "success"
        ? colorConfig.successAppointement
        : props.status === "default"
        ? colorConfig.secondaryDark
        : props.status === "noshow"
        ? colorConfig.noShowAppointment
        : props.status === "show"
        ? colorConfig.primaryDark
        : colorConfig.schedualStatusAppointment};
    color: ${colorConfig.WHITE};
  }

  @media (max-width: 992px) {
    height: 5px;
    margin: 2px 0;
    background: ${props =>
      props.status === "error"
        ? colorConfig.cancelAppointement
        : props.status === "success"
        ? colorConfig.successAppointement
        : props.status === "default"
        ? colorConfig.secondaryDark
        : props.status === "noshow"
        ? colorConfig.noShowAppointment
        : props.status === "show"
        ? colorConfig.primaryDark
        : colorConfig.schedualStatusAppointment};
    color: ${colorConfig.WHITE};
`;

const CalendarContainer = styled.div`
  border-right: 1px solid rgb(232, 232, 232);
  border-bottom: 1px solid rgb(232, 232, 232);
  padding: 10px 5px;
  & .ant-fullcalendar-fullscreen {
    font-family: Roboto, sans-serif !important;
    & .ant-fullcalendar-table .ant-fullcalendar-column-header-inner {
      font-size: 18px;
      font-weight: 600;
      padding: 10px 0;
    }
  }
  & .ant-fullcalendar-header {
    padding: 4px 16px 8px 0;
    . ant-radio-group {
      dispaly: none;
    }
  }
`;

const { Search } = Input;
let panelChangeDate = null;

const Appointments = props => {
  const {
    lead = null,
    onBackClick,
    onClick = () => {},
    leadOpportunities,
    handleLeadDetailProfile,
    eventId,
    assignedUserId,
    refetchLeads,
    refreshLeadListData,
    selectedOppTypeId = null,
    // EAI-843: pin the whole section to the viewport so its calendar / list
    // panes scroll internally instead of growing the document. Only the
    // Engagements tab passes it — the "add appointment" drawer and the
    // browser-extension pages keep their own sizing.
    fitToViewport = false,
  } = props;

  const { user } = useContext(UserContext);
  const [lang] = useLang();
  const dispatch = useDispatch();
  const { filters } = useSelector(state => state.appointments);
  const {
    userIds,
    appointmentStatus,
    range,
    userMode,
    calendarMode,
    dateMode,
    dateType,
    opportunityTypeId: reduxOpportunityTypeId,
    customRange,
    entityMode,
    activeFilterMode,
    teamIds,
    viewMode,
    opportunitySourceIds,
    cameFromDashboard,
  } = filters;
  // API payload is keyed off the committed mode (`activeFilterMode`), NOT the
  // visible toggle (`entityMode`) — so flipping the toggle without selecting
  // anything doesn't change which list is sent to the BE.
  const isTeamsMode = activeFilterMode === ENTITY_MODE.TEAMS;
  // When set, the user may only view their own data: pin the logged-in user
  // as the selected value in the EntityFilter and lock it. Mirrors
  // DashboardFilterContext's handling of the same permission.
  const restrictRemoveDefaultFilter = checkAccessPermission(
    AccessPermissionAction.ACTIVITY_CENTER_RESTRICT_REMOVE_DEFAULT_FILTER
  );
  const locationId = useSelector(getLocationId);
  const prevLocationIdRef = useRef(locationId);

  const isCustomRangeMode = dateType === CUSTOM;
  const hasCustomRangeDates = !!customRange?.startDate && !!customRange?.endDate;
  const effectiveRange = isCustomRangeMode ? customRange : range;
  const shouldSkipRangeQuery = isCustomRangeMode && !hasCustomRangeDates;
  // <= 31 days fits in a single dayGridMonth (6-week) panel; beyond that,
  // list view scales without paginated month navigation.
  const CUSTOM_RANGE_GRID_DAY_LIMIT = 31;
  const customRangeDays =
    isCustomRangeMode && hasCustomRangeDates
      ? dayjs(customRange.endDate).diff(dayjs(customRange.startDate), "day") + 1
      : 0;
  const customRangeUsesGrid =
    isCustomRangeMode && hasCustomRangeDates && customRangeDays <= CUSTOM_RANGE_GRID_DAY_LIMIT;

  // FullCalendar opens at "today" by default — which means a dashboard
  // drill-in with LAST_MONTH lands the user on June even though the data
  // is for May. Compute the initial focus date from the active preset so
  // the calendar opens at the same window the BE is filtering by.
  // Resolution:
  //   - CUSTOM range → start of the custom window (existing behavior).
  //   - Named preset → range start from `getDateRangeFromFilter` (e.g.
  //     LAST_MONTH → May 1, LAST_WEEK → last Monday, YESTERDAY → yesterday).
  //   - CALENDAR_VIEW or anything unrecognized → today (FullCalendar default).
  const calendarInitialDate = useMemo(() => {
    if (isCustomRangeMode) {
      return hasCustomRangeDates ? customRange.startDate : undefined;
    }
    if (!dateType || dateType === CALENDAR_VIEW) return undefined;
    const range = getDateRangeFromFilter(dateType);
    if (!Array.isArray(range) || !range[0]) return undefined;
    return dayjs(range[0]).format(DATE_TIME_FORMATS.YYYY_MM_DD);
  }, [isCustomRangeMode, hasCustomRangeDates, customRange?.startDate, dateType]);
  const { refetchAppointments, setrefetchAppointments } = useContext(UserContext);
  const [openAppointmentPopup, setAppointmentPopupVisible] = useState(false);
  const [filterSetting, setfilterSetting] = useState(2);
  const [appointment, setAppointment] = useState({});
  const calendarRef = React.createRef();
  const prevMonthRangeRef = useRef(null);
  const [defaultDate, setDefaultDate] = useState(null);
  const [selectedUser, setSelectedUser] = useState([]);
  const [search, setSearch] = useState("");
  const [userSearch, setuserSearch] = useState("");
  const [shouldRenderComponent, setShouldRenderComponent] = useState(false);
  const [userList, setUserList] = useState([
    { id: user?.id, name: `${user?.firstName} ${user?.lastName}`, ...user },
  ]);

  const [opportunityTypes, setopportunityTypes] = useState([]);

  const { loading: opportunityTypesLoader } = useQuery(GET_OPPORTUNITTIES_TYPES, {
    fetchPolicy: "cache-first",
    variables: {
      industryId: 1,
    },
    onCompleted: res => {
      setopportunityTypes(res?.getOpportunityTypes || []);
    },
  });

  const [createdByUser, setcreatedByUser] = useState([]);
  useEffect(() => {
    if (user.id) {
      setSelectedUser([!isUndefined(assignedUserId) ? +assignedUserId : +user?.id]);
      setcreatedByUser([!isUndefined(assignedUserId) ? +assignedUserId : +user?.id]);
    }
  }, [assignedUserId, user.id]);

  const [filterValue, setfilterValue] = useState([
    "SCHEDULED",
    "NO_SHOWED",
    "SHOWED",
    "CANCELLED",
    "CONFIRMED",
    "RESCHEDULED",
    "VIRTUAL",
  ]);
  const [variables, setVariables] = useState({
    userIds: selectedUser,
    startDate: dayjs().utc().startOf("month").format("YYYY-MM-DD"),
    endDate: dayjs().utc().endOf("month").format("YYYY-MM-DD"),
    companyId: user?.company?.id,
    createdByUserIds: createdByUser,
    appointmentStatus: filterValue,
    // page: 1,
    // pageSize: 10,
    orderBy: "start_datetime",
    orderDirection: "desc",
    dateFilter: null,
    leadOpportunities: [],
    filterDateType: dateMode,
    filterType: dateType,
    opportunityTypeId: reduxOpportunityTypeId ? parseInt(reduxOpportunityTypeId) : null,
  });

  useEffect(() => {
    if (user) {
      setVariables({
        ...variables,
        companyId: user.company.id,
        createdByUserIds: createdByUser,
        userIds: selectedUser,
        opportunityTypeId: reduxOpportunityTypeId ? parseInt(reduxOpportunityTypeId) : null,
      });
    }
  }, [user, selectedUser, createdByUser]);

  const pagePath = window.location.pathname;
  const filterOption = sessionStorage.getItem("appointmentFilterType");

  useEffect(() => {
    if (filterOption) {
      setfilterSetting(+filterOption);
    }
  }, [filterOption]);

  useEffect(() => {
    // Your logic here
    // If you want to conditionally render a component, update the state.
    setShouldRenderComponent(true);
  }, []);

  // When the global location changes, the previously-selected user filter
  // becomes stale (those users belong to the old location). Reset to the
  // logged-in user so the calendar shows something meaningful immediately.
  // If the user had "All" picked, UserSelector will overwrite this with the
  // new location's full user list once its refetch completes.
  useEffect(() => {
    if (prevLocationIdRef.current !== locationId) {
      prevLocationIdRef.current = locationId;
      if (user?.id) {
        dispatch(reducerSetAppointmentUserIds([+user.id]));
      }
    }
  }, [locationId, user?.id]);

  const [calendarApi, setcalendarApi] = useState(null);

  useEffect(() => {
    if (calendarRef && calendarRef.current && calendarRef.current.getApi())
      setcalendarApi(calendarRef?.current?.getApi());
  }, [calendarRef, shouldRenderComponent]);

  // FullCalendar reads `initialDate` only on first mount, so changing the
  // date preset later (or arriving from a dashboard drill-in after the
  // calendar already mounted) won't reposition the view. Imperatively
  // navigate via the API when the resolved focus date changes.
  // Deferred to a microtask: `gotoDate` calls `flushSync` internally, and
  // doing it synchronously inside the effect can collide with React 18's
  // commit phase ("flushSync was called from inside a lifecycle method").
  // `queueMicrotask` runs after the current render flushes, so the warning
  // is gone and the navigation still happens in the same frame.
  useEffect(() => {
    if (!calendarApi || !calendarInitialDate) return undefined;
    let cancelled = false;
    queueMicrotask(() => {
      if (cancelled) return;
      calendarApi.gotoDate(calendarInitialDate);
    });
    return () => {
      cancelled = true;
    };
  }, [calendarApi, calendarInitialDate]);

  // Snapshot the dashboard-drill-in flag into local state on first render,
  // then clear the redux flag so a later direct visit doesn't reuse it. The
  // snapshot survives any subsequent re-renders (including the StrictMode
  // double-mount in dev), so the note stays visible while the user is on
  // this view.
  const [showDashboardNote, setShowDashboardNote] = useState(false);
  useEffect(() => {
    if (cameFromDashboard) {
      setShowDashboardNote(true);
      dispatch(reducerSetAppointmentFilters({ cameFromDashboard: false }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Restricted users see only their own data: pin the logged-in user in the
  // EntityFilter (Users mode) and lock it via `disabled` below. Skip if the
  // current user is already the sole pinned selection.
  useEffect(() => {
    if (!restrictRemoveDefaultFilter || !user?.id) return;
    const selfId = +user.id;
    const alreadyPinned =
      activeFilterMode === ENTITY_MODE.USERS &&
      Array.isArray(userIds) &&
      userIds.length === 1 &&
      +userIds[0] === selfId;
    if (alreadyPinned) return;
    dispatch(
      reducerSetAppointmentFilters({
        userIds: [selfId],
        teamIds: [],
        entityMode: ENTITY_MODE.USERS,
        activeFilterMode: ENTITY_MODE.USERS,
      })
    );
  }, [restrictRemoveDefaultFilter, user?.id, activeFilterMode, userIds, dispatch]);
  /**
   *
   * @param {import("@fullcalendar/core/index.js").DatesSetArg} dateInfo
   */
  const handleDatesSet = dateInfo => {
    // In Custom mode the range is user-controlled via the RangePicker, so
    // don't let FullCalendar navigation overwrite it.
    if (!isCustomRangeMode) {
      dispatch(
        reducerSetAppointmentRange({
          startDate: dayjs(dateInfo.start).format("YYYY-MM-DD"),
          endDate: dayjs(dateInfo.end).subtract(1, "day").format("YYYY-MM-DD"),
        })
      );
    }
    // Only persist standard views. "appointmentCustom" / "list" would poison
    // calendarMode so that after leaving Custom mode the next initialView would
    // be an invalid view and the month/week/day toggle wouldn't highlight.
    if (STANDARD_CALENDAR_VIEWS.includes(dateInfo.view.type)) {
      dispatch(reducerSetAppointmentCalendarMode(dateInfo.view.type));
    }

    // Handle month view tracking for dropdown reset logic.
    // Skip in Custom mode — the user explicitly chose Custom and the range is
    // driven by the RangePicker, not by calendar navigation. Without this guard
    // the initial datesSet fired after remount would reset dateType to
    // CALENDAR_VIEW and wipe the user's selection.
    if (dateInfo.view.type === "dayGridMonth" && !isCustomRangeMode) {
      const currentRange = {
        start: dayjs(dateInfo.start).format(DATE_TIME_FORMATS.YYYY_MM),
        end: dayjs(dateInfo.end).format(DATE_TIME_FORMATS.YYYY_MM),
      };
      const prevRange = prevMonthRangeRef.current;

      // Only reset dateType when there's actual month/year navigation
      // Don't reset when switching from other views back to month view within same period
      if (
        prevRange &&
        (prevRange.start !== currentRange.start || prevRange.end !== currentRange.end)
      ) {
        dispatch(reducerSetAppointmentDateType(CALENDAR_VIEW));
      }

      // Always update the range reference when in month view
      prevMonthRangeRef.current = currentRange;
    }
    // Note: Removed the else block that was resetting prevMonthRangeRef to undefined
    // This allows the month range to persist when switching between grid views
  };

  const { data: respWorkHrs } = useQuery(GET_COMPANY_WORK_HOURS, {
    variables: {
      companyId: user?.company?.id || 0,
      locationId: parseInt(sessionStorage.getItem("currentLocationId") || 0),
    },
  });
  const canAddUsers = checkAccessPermission("APPOINTMENT_MANAGEMENT_ALLOW_LOCATION_APPOINTMENTS");
  const canView = checkAccessPermission(AccessPermissionAction.APPOINTMENT_VIEW);

  const worksHours = respWorkHrs?.getCompanyWorkingHours || [];

  const { loading: userLoading } = useQuery(GET_ALL_USERS, {
    variables: {
      companyId: user?.company?.id || 0,
      isGlobalLeadOwner: true,
      isLocationFilter: true,
      isActive: true,
      search: userSearch,
      locationIds: sessionStorage.getItem("currentLocationId")?.split(","),
    },
    // fetchPolicy: "network-only",
    onCompleted: res => {
      const users = res?.getUsers?.data || [];
      const findIndex = users.findIndex(el => +el.id === +user?.id);
      if (findIndex > -1) {
        const user = [users[findIndex].id];
        setSelectedUser([+assignedUserId || +user]);
        setcreatedByUser([+assignedUserId || +user]);
        setVariables({ ...variables });
      }
      const userListArray = (res?.getUsers?.data || []).map(el => ({
        id: el.id,
        name: `${el.firstName} ${el.lastName}`,
        ...el,
      }));

      userListArray.sort((a, b) => {
        const nameA = a.name.toUpperCase(); // ignore upper and lowercase
        const nameB = b.name.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });

      setUserList(userListArray);
    },
  });
  const [getUserAppointments, { data: resp, refetch, loading: loader }] = useLazyQuery(
    APPOINTMENT_CALENDAR,
    {
      fetchPolicy: "network-only",
    }
  );
  useEffect(() => {
    if (shouldSkipRangeQuery) return;
    // Per BE contract, startDate/endDate are only honored for an explicit
    // window — Custom (filterType null) and Calendar view. Named presets
    // (Today / This Week / Last Week / ...) must NOT send start/end; the
    // backend derives the range from filterType. This also keeps the
    // dashboard → appointment redirect clean: presets carry only filterType.
    const usesExplicitRange = isCustomRangeMode || dateType === CALENDAR_VIEW;
    getUserAppointments({
      variables: {
        // Teams mode → send only teamIds; clear user-side fields so the BE
        // doesn't intersect both filters. Users mode → existing split between
        // assigned (userMode 1) and created-by (userMode 0).
        userIds: isTeamsMode ? null : userMode === 1 ? userIds : null,
        createdByUserIds: isTeamsMode ? null : userMode === 0 ? userIds : null,
        teamIds: isTeamsMode && teamIds?.length > 0 ? teamIds : null,
        startDate: usesExplicitRange ? effectiveRange.startDate : null,
        endDate: usesExplicitRange ? effectiveRange.endDate : null,
        leadId: (lead && +lead?.id) || null,
        companyId: user?.company?.id,
        appointmentStatus: appointmentStatus,
        orderBy: "start_datetime",
        orderDirection: "desc",
        leadOpportunities: [],
        search: search,
        filterDateType: dateMode,
        // In CUSTOM mode we send filterType: null so the backend uses the
        // explicit startDate/endDate without applying a named preset.
        filterType: isCustomRangeMode ? null : dateType,
        opportunityTypeId: reduxOpportunityTypeId ? parseInt(reduxOpportunityTypeId) : null,
        // Carried over from dashboard drill-ins (waterfall vs current-status
        // toggle, source filter). null/[] when the user landed here directly.
        viewMode: viewMode || null,
        opportunitySourceIds:
          Array.isArray(opportunitySourceIds) && opportunitySourceIds.length > 0
            ? opportunitySourceIds
            : null,
      },
    });
  }, [
    appointmentStatus,
    userMode,
    range,
    customRange,
    userIds,
    refetchAppointments,
    search,
    dateType,
    dateMode,
    reduxOpportunityTypeId,
    entityMode,
    teamIds,
    viewMode,
    opportunitySourceIds,
  ]);

  const count = resp?.getUserAppointment?.count;

  const appointments = (resp?.getUserAppointment?.data || []).map(el => ({
    ...el,
    type:
      el.appointmentStatus === "CANCELLED"
        ? "error"
        : el.appointmentStatus === "SHOWED"
        ? "show"
        : el.appointmentStatus === "NO_SHOWED"
        ? "noshow"
        : el.isConfirmed
        ? "success"
        : el.appointmentStatus === "SCHEDULED"
        ? "scheduled"
        : el.appointmentStatus === "RESCHEDULED"
        ? "rescheduled"
        : "default",
    content: el.summary,
  }));

  const handleAppointmentModalClose = (status, isPopClosed = true) => {
    setAppointmentPopupVisible(false);
    setAppointment(null);
    if (isPopClosed) {
      setDefaultDate(null);
      panelChangeDate = null;
      if (status) {
        refetch();
      }
    }
  };

  const handleAppointmentDialog = (
    appointmentHeader,
    appointmentDetails,
    date,
    fetchMoreDetails = false
  ) => {
    // eslint-disable-next-line no-debugger
    const tempAppointments = { ...appointmentDetails, id: appointmentDetails?.appointmentId };
    const leadAppointmentDetails =
      appointmentDetails?.lead ||
      (appointmentDetails && appointments?.find(item => +item.id === +tempAppointments.id)?.lead);
    openDialog("appointmentForm", {
      showLeadChanger: !appointmentDetails,
      dialogHeader: appointmentHeader || lang.createAppointment,
      lead: isEmpty(lead) ? leadAppointmentDetails : lead,
      eventId: eventId,
      visibleModal: openAppointmentPopup,
      appointment: tempAppointments || appointment,
      defaultDate: date || dayjs(),
      mode: appointmentDetails ? "EDIT" : "ADD",
      refetchLeads,
      fetchMoreDetails,
      setAppointmentModelVisible: handleAppointmentModalClose,
      handleDialogClose: () => handleAppointmentModalClose(false, false),
      refetchAppointments,
      setrefetchAppointments,
      refreshLeadListData,
      leadOpportunities:
        leadOpportunities ||
        appointmentDetails?.lead?.leadOpportunities ||
        appointment?.lead?.leadOpportunities ||
        [],
      // Active opp-type tab (Sales/Service/...) — used by the form
      // to default the opp-select to the most-recent opp under this
      // root in ADD mode.
      selectedOppTypeId,
      redirect: (e, updatedDate, needToRedirect = true, leadId = "", isClickOnName = false) => {
        if (isEmpty(lead) && e && needToRedirect) {
          try {
            onClick &&
              onClick({
                data: appointmentDetails?.lead || appointment?.lead || lead,
                tab: "activity-center",
                updatedDate,
              });
            // window.localStorage.setItem(
            //   "changedLocationLeadId",
            //   appointmentDetails?.lead?.id || appointment?.lead?.id || lead?.id
            // );
            !pagePath.includes("chat-bot") &&
              !pagePath.includes("browser-ext") &&
              window.history.pushState("", "", "/engagements/activity-center");
            // !pagePath.includes("chat-bot") &&
            //   !pagePath.includes("browser-ext") &&
            //   tabContext.setActiveTab("activity-center");
          } catch (err) {
            console.log(err);
          }
        } else if (needToRedirect) {
          try {
            onClick &&
              onClick(
                appointmentDetails?.lead || appointment?.lead || lead,
                true,
                updatedDate,
                isClickOnName
              );
            !pagePath.includes("chat-bot") &&
              !pagePath.includes("browser-ext") &&
              window.history.pushState("", "", "/engagements/activity-center");
            // !pagePath.includes("chat-bot") &&
            //   !pagePath.includes("browser-ext") &&
            //   tabContext.setActiveTab("activity-center");
          } catch (err) {
            console.log(err);
          }
        }
      },
      activeAppointments: (appointments || []).filter(el =>
        ["default", "processing"].includes(el.type)
      ),
      handleLeadDetailProfile: handleLeadDetailProfile,
      allowLeadChange: false,
    });
  };
  const [getAppointmentFormDetails, { loading: appointmentFormLoader }] = useLazyQuery(
    GET_REMAINING_APPOINTMENT_FORM_DETAILS,
    // network-only: the edit form needs live data. cache-first served stale
    // startDatetime / summary when reopening an appointment right after save.
    { fetchPolicy: "network-only" }
  );
  const messageRef = useRef(null);

  useEffect(() => {
    if (appointmentFormLoader)
      messageRef.current = message.loading("Fetching appointment details", 0);
    else {
      messageRef.current && messageRef.current();
    }
  }, [appointmentFormLoader]);

  const closeAllPopovers = () => {
    document.activeElement?.blur();

    setTimeout(() => {
      try {
        if (isFunction(document.body.click)) {
          document.body.click();
        }

        const fc = document.querySelectorAll(".fc-more-popover");
        const ant = document.querySelectorAll(".ant-popover");

        fc?.forEach(el => {
          el.remove();
        });

        Array.from(ant)?.forEach(el => {
          if (el?.style) {
            el.style.display = "none";
            el.style.visibility = "hidden";
            el.style.opacity = "0";
          }
        });
      } catch (err) {
        console.error("[closeAllPopovers] Cleanup failed:", err);
      }
    }, 10);
  };

  const handleEventClick = async (e, item) => {
    if (e) {
      if (canView) {
        e.stopPropagation();

        // TODO: Fetch other required details from the server for the appointment form
        const remainingResponse = await getAppointmentFormDetails({
          variables: {
            appointmentId: item.appointmentId,
          },
        });
        const remainingDetails = remainingResponse?.data?.getAppointmentDetails;
        const appointmentData = {
          ...item,
          ...remainingDetails,
          lead: { ...item.lead, ...remainingDetails?.lead },
        };
        setAppointment(appointmentData);
        setAppointmentPopupVisible(true);
        closeAllPopovers();
        handleAppointmentDialog(
          "Edit Appointment",
          appointmentData,
          dayjs(item.startDatetime),
          true
        );
      } else {
        message.error(lang.permissionError);
      }
    }
  };

  const vehicles = vehicles => {
    let list = [];
    if (vehicles.length > 0) {
      list = vehicles.map(el => {
        let voi = "";
        if (isValidYear(el.year)) voi = `${voi + el.year} `;
        if (!isUndefined(el.make) && el.make !== null && el.make !== undefined && el.make !== 0)
          voi = `${voi + el.make} `;
        if (!isUndefined(el.model) && el.model !== null && el.model !== undefined && el.model !== 0)
          voi = `${voi + el.model} `;
        return voi === "" || voi === 0 ? (
          <Tag color="green">{lang.noVehicles}</Tag>
        ) : (
          <Tooltip
            placement="topLeft"
            title={el?.isCurrent ? lang.previousOrCurrentVehicle : lang.vehicleOfInterest}
          >
            <p>
              <Tag color={el?.isCurrent ? "magenta" : "blue"}>{voi}</Tag>
            </p>
          </Tooltip>
        );
      });
    } else {
      return <Tag color="green">No Vehicles</Tag>;
    }
    return list;
  };

  const onSelectDate = (startDate, endDate) => {
    const isValidDay = worksHours.filter(day => {
      if (day.weekDay.toLowerCase() === startDate.format("dddd").toLowerCase()) {
        return day;
      }
    });
    if (isValidDay[0]?.isWorkingDay) {
      if (!isEmpty(lead) && isUndefined(appointment?.id)) {
        if (dayjs().format("YYYY-MM-DD") > startDate.format("YYYY-MM-DD")) {
          message.error(lang.appointmentInPast);
        } else {
          if (!canView) {
            return;
          }
          setDefaultDate(panelChangeDate || startDate);
          panelChangeDate = null;
          handleAppointmentDialog("", "", panelChangeDate || startDate);
        }
      }
    } else {
      message.error(lang.nonWorkingDay);
    }
  };

  const onPanelChange = value => {
    if (!isEmpty(value)) {
      setVariables({
        ...variables,
        startDate: value?.utc()?.startOf("month")?.format("YYYY-MM-DD"),
        endDate: value?.utc()?.endOf("month")?.format("YYYY-MM-DD"),
      });
    }
  };

  const canSchedule = checkAccessPermission(AccessPermissionAction?.APPOINTMENT_SCHEDULE);

  const handleFilters = value => {
    if (appointmentStatus?.includes(value)) {
      // remove the filter
      dispatch(reducerSetAppointmentStatus(appointmentStatus.filter(item => item !== value)));
    } else {
      // add the filter
      dispatch(reducerSetAppointmentStatus([...appointmentStatus, value]));
      // setfilterValue([...filterValue, value]);
    }
    setSearch("");
  };

  const BADGES = [
    {
      badgeColor: colorConfig.steelBlue,
      onClickLabel: APPOINTMENT_STATUS.SCHEDULED,
      tag: "Scheduled",
      bgColor: APPOINTMENT_STATUS_COLORS[APPOINTMENT_STATUS.SCHEDULED].bg,
      borderColor: APPOINTMENT_STATUS_COLORS[APPOINTMENT_STATUS.SCHEDULED].border,
      textColor: APPOINTMENT_STATUS_COLORS[APPOINTMENT_STATUS.SCHEDULED].text,
    },
    {
      badgeColor: colorConfig.cyan,
      onClickLabel: APPOINTMENT_STATUS.RESCHEDULED,
      tag: "Rescheduled",
      bgColor: APPOINTMENT_STATUS_COLORS[APPOINTMENT_STATUS.RESCHEDULED].bg,
      borderColor: APPOINTMENT_STATUS_COLORS[APPOINTMENT_STATUS.RESCHEDULED].border,
      textColor: APPOINTMENT_STATUS_COLORS[APPOINTMENT_STATUS.RESCHEDULED].text,
    },
    {
      badgeColor: colorConfig.green,
      onClickLabel: APPOINTMENT_STATUS.CONFIRMED,
      tag: "Confirmed",
      bgColor: APPOINTMENT_STATUS_COLORS[APPOINTMENT_STATUS.CONFIRMED].bg,
      borderColor: APPOINTMENT_STATUS_COLORS[APPOINTMENT_STATUS.CONFIRMED].border,
      textColor: APPOINTMENT_STATUS_COLORS[APPOINTMENT_STATUS.CONFIRMED].text,
    },
    {
      badgeColor: colorConfig.coral,
      onClickLabel: APPOINTMENT_STATUS.CANCELLED,
      tag: "Cancelled",
      bgColor: APPOINTMENT_STATUS_COLORS[APPOINTMENT_STATUS.CANCELLED].bg,
      borderColor: APPOINTMENT_STATUS_COLORS[APPOINTMENT_STATUS.CANCELLED].border,
      textColor: APPOINTMENT_STATUS_COLORS[APPOINTMENT_STATUS.CANCELLED].text,
    },
    {
      badgeColor: colorConfig.primaryDark,
      onClickLabel: APPOINTMENT_STATUS.SHOWED,
      tag: "Showed",
      bgColor: APPOINTMENT_STATUS_COLORS[APPOINTMENT_STATUS.SHOWED].bg,
      borderColor: APPOINTMENT_STATUS_COLORS[APPOINTMENT_STATUS.SHOWED].border,
      textColor: APPOINTMENT_STATUS_COLORS[APPOINTMENT_STATUS.SHOWED].text,
    },
    {
      badgeColor: colorConfig.grey,
      onClickLabel: APPOINTMENT_STATUS.NO_SHOWED,
      tag: "No Showed",
      bgColor: APPOINTMENT_STATUS_COLORS[APPOINTMENT_STATUS.NO_SHOWED].bg,
      borderColor: APPOINTMENT_STATUS_COLORS[APPOINTMENT_STATUS.NO_SHOWED].border,
      textColor: APPOINTMENT_STATUS_COLORS[APPOINTMENT_STATUS.NO_SHOWED].text,
    },
  ];

  const renderAppointment = item => {
    // "timeGridWeek"
    // "dayGridMonth"
    // "timeGridDay"

    const getStyle = appointmentDetails => {
      const status = appointmentDetails.appointmentStatus.toLowerCase();
      switch (status) {
        case "scheduled":
          return {
            backgroundColor: "#BAE0FF",
            borderColor: "#1677FF",
          };
        case "rescheduled":
          return {
            backgroundColor: "#EFDBFF",
            borderColor: "#722ED1",
          };
        case "confirmed":
          return {
            backgroundColor: "#B5F5EC",
            borderColor: "#13C2C2",
          };
        case "cancelled":
          return {
            backgroundColor: "#FFCCC7",
            borderColor: "#F5222D",
          };
        case "showed":
          return {
            backgroundColor: "#A7F2CF",
            borderColor: "#52C41A",
          };
        case "no_showed":
          return {
            backgroundColor: "#D9D9D9",
            borderColor: "#595959",
          };
        default:
          return {
            backgroundColor: "#D9D9D9",
            borderColor: "#595959",
          };
      }
    };

    const getAppoitmentStatusColor = () => ({ color: "#000000E0" });

    const currentViewType = calendarApi?.currentData?.currentViewType || calendarMode;

    return (
      // <LIWrap
      //   key={item.appoinmentId}
      //   onClick={e => {
      //     handleEventClick(e, item);
      //   }}
      //   status={item.type}
      // >
      <Popover
        content={<PopoverContent item={item} vehicles={vehicles} />}
        title={(() => {
          const opportunityType = item?.leadOpportunity?.opportunityType;
          const rootName = getRootOpportunityTypeName(opportunityType);
          const normalized = (rootName || "").toLowerCase();
          const showTag = normalized === "sales" || normalized === "service";
          return (
            <div className="flex items-center justify-between gap-2 w-full">
              <span>Appointment Details</span>
              {showTag && (
                <Tag color={normalized === "sales" ? "blue" : "orange"} style={{ marginRight: 0 }}>
                  <span className="inline-flex items-center gap-1">
                    <OpportunityTypeIcon opportunityType={opportunityType} />
                    {rootName}
                  </span>
                </Tag>
              )}
            </div>
          );
        })()}
        className="max-w-[350px]"
        placement="right"
        destroyTooltipOnHide
      >
        {/* <Badge
            className="w-1/2"
            status={item.type}
            text={`${convertUtcToLocal(item.startDatetime, "h:mm a")} - ${item.content}`}
          /> */}
        <div
          key={item.appoinmentId}
          onClick={e => {
            handleEventClick(e, item);
          }}
          className="flex flex-row items-center h-full w-full"
        >
          <span
            className={`overflow-hidden rounded-[4px] text-xs ${
              currentViewType === "dayGridMonth"
                ? "w-full"
                : "w-full border-l-[3px] border-t-0 border-r-0 border-b-0 border-solid flex flex-col"
            } px-[4px] py-[6px] h-full`}
            style={{
              ...getStyle(item),
              color: "#000000E0",
            }}
          >
            {currentViewType === "dayGridMonth" ? (
              <span className="flex items-center gap-1 w-full overflow-hidden whitespace-nowrap">
                <OpportunityTypeIcon
                  opportunityType={item?.leadOpportunity?.opportunityType}
                  className="flex-shrink-0"
                />
                <span className="truncate">
                  {`${
                    item?.extraData?.is_tentative_appointment_time
                      ? "Tentative Time"
                      : convertUtcToLocal(item.startDatetime, "h:mm a")
                  } - ${item.content}`}
                </span>
              </span>
            ) : (
              <div className="flex flex-row items-start gap-1">
                <OpportunityTypeIcon
                  opportunityType={item?.leadOpportunity?.opportunityType}
                  className="mt-1 flex-shrink-0"
                />
                <div className="flex flex-col items-start">
                  <span className="text-sm font-[500]">
                    {item?.extraData?.is_tentative_appointment_time
                      ? "Tentative Time"
                      : convertUtcToLocal(item.startDatetime, "h:mm a")}
                  </span>
                  <span className="text-sm font-[600]">{item.content}</span>
                </div>
              </div>
            )}
          </span>
        </div>
      </Popover>
      // </LIWrap>
    );
  };

  return (
    <Container
      border={0}
      auto
      noMargin={!isEmpty(lead)}
      /* EAI-843: 174px is everything this section sits inside — app header (56)
         + content padding (24) + tab wrapper padding (8) + tab strip (38)
         + tab-pane top margin (16) + this container's own bottom margin (32).
         Gated at lg because below it the two columns stack and scrolling the
         page is the right behaviour. */
      className={
        fitToViewport
          ? "lg:h-[calc(100vh-174px)] lg:flex lg:flex-col lg:overflow-hidden"
          : undefined
      }
    >
      {/* Dashboard drill-in note — captured into local state on first
          render (see effect above) so it survives the redux flag being
          cleared. Explains why the appointment count here may exceed the
          dashboard cell the user clicked from. */}
      <div className="block md:flex items-center justify-between shrink-0">
        <div
          className="block rounded-[2px] border-[1px] p-3 sm:p-5 border-solid border-grey-200 mb-2 w-full"
          id="antdUserDropdown"
        >
          <div className="flex flex-col xl:flex-row gap-3 w-full xl:items-start">
            {/* Filters Section */}
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 flex-1 w-full">
              {/* Opportunity Type Filter */}
              <div className="flex flex-col justify-start h-full">
                <div className="flex flex-col gap-1">
                  <label className="text-xs font-medium text-gray-700">Opportunity Type</label>
                  <OpportunityTypeCascader
                    opportunityTypes={opportunityTypes}
                    opportunityTypesLoader={opportunityTypesLoader}
                    form={null}
                    canAddEditOpportunity
                    value={variables.opportunityTypeId}
                    onChange={value => {
                      setVariables(prev => ({
                        ...prev,
                        opportunityTypeId: value,
                      }));
                      dispatch(reducerSetOpportunityTypeId(value));
                    }}
                    allowParentSelection
                    expandTrigger="click"
                    className="w-full"
                    style={{ width: "100%" }}
                    showAllOption
                  />
                </div>
              </div>

              {/* User Filter */}
              <div className="flex flex-col justify-start h-full">
                <div className="flex flex-col gap-1">
                  <Radio.Group
                    value={userMode}
                    onChange={e => {
                      dispatch(reducerSetAppointmentUserMode(e.target.value));
                    }}
                    className="w-full"
                  >
                    <Radio value={0} className="text-xs">
                      {lang.createdBy}
                    </Radio>
                    <Radio value={1} className="text-xs">
                      {lang.assignedTo}
                    </Radio>
                  </Radio.Group>
                  {/* Same Users / Teams toggle the dashboard uses. The page
                      still owns the Created-By vs Assigned-To radio above —
                      that's orthogonal to entity mode and only applies when
                      Users is selected; in Teams mode the payload uses
                      `teamIds` directly. EntityFilter fetches its own teams
                      list when `teams` prop is omitted. */}
                  <EntityFilter
                    className="w-full"
                    mode={entityMode || ENTITY_MODE.USERS}
                    onModeChange={mode =>
                      dispatch(reducerSetAppointmentFilters({ entityMode: mode }))
                    }
                    userIds={userIds}
                    // Selecting commits: the chosen mode becomes the active
                    // filter mode, the OTHER list is cleared so we don't carry
                    // a stale selection across modes. Mirrors the dashboard's
                    // selectUserIds / selectTeamIds setters.
                    onUserIdsChange={ids =>
                      dispatch(
                        reducerSetAppointmentFilters({
                          userIds: ids,
                          teamIds: [],
                          activeFilterMode: ENTITY_MODE.USERS,
                        })
                      )
                    }
                    teamIds={teamIds || []}
                    onTeamIdsChange={ids =>
                      dispatch(
                        reducerSetAppointmentFilters({
                          teamIds: ids,
                          userIds: [],
                          activeFilterMode: ENTITY_MODE.TEAMS,
                        })
                      )
                    }
                    committed={(entityMode || ENTITY_MODE.USERS) === activeFilterMode}
                    activeMode={activeFilterMode}
                    disabled={restrictRemoveDefaultFilter}
                  />
                </div>
              </div>

              {/* Opportunity Source Filter */}
              <div className="flex flex-col justify-start h-full">
                <div className="flex flex-col gap-1">
                  <span className="text-xs text-black-65">Opportunity Source</span>
                  <OpportunitySourceSelect
                    className="w-full min-w-[200px]"
                    value={opportunitySourceIds || []}
                    onChange={ids =>
                      dispatch(reducerSetAppointmentFilters({ opportunitySourceIds: ids || [] }))
                    }
                  />
                </div>
              </div>

              {/* View Mode — same Switch + "Current Status" pattern the
                  dashboard uses (and Lead Center now uses too). Switch on =
                  Normal (current status), off = Waterfall (stage progression). */}
              <div className="flex flex-col justify-start h-full">
                <div className="flex flex-col gap-1">
                  <span className="text-xs text-black-65">View Mode</span>
                  <span className="flex-row-centered gap-2 text-sm">
                    <Switch
                      size="small"
                      checked={(viewMode || "normal") === "normal"}
                      onChange={checked =>
                        dispatch(
                          reducerSetAppointmentFilters({
                            viewMode: checked ? "normal" : "waterfall",
                          })
                        )
                      }
                    />
                    Current Status
                  </span>
                </div>
              </div>

              {/* Date Filter */}
              <div className="flex flex-col justify-start h-full">
                <div className="flex flex-col gap-1">
                  <Radio.Group
                    value={dateMode}
                    onChange={e => {
                      dispatch(reducerSetAppointmentDateMode(e.target.value));
                    }}
                    className="w-full"
                  >
                    <Radio value={APPOINTMENT_DATE_MODE.CREATED_ON} className="text-xs">
                      {lang.createdOn}
                    </Radio>
                    <Radio value={APPOINTMENT_DATE_MODE.DUE_ON} className="text-xs">
                      {lang.dueOn}
                    </Radio>
                  </Radio.Group>
                  <Select
                    className="w-full"
                    size="medium"
                    value={dateType}
                    onChange={value => {
                      dispatch(reducerSetAppointmentDateType(value));
                    }}
                    options={[
                      {
                        label: lang.calendarView,
                        value: CALENDAR_VIEW,
                      },
                      {
                        label: lang.today,
                        value: "TODAY",
                      },
                      {
                        label: "Yesterday",
                        value: "YESTERDAY",
                      },
                      {
                        label: lang.thisWeek,
                        value: "THIS_WEEK",
                      },
                      {
                        label: "Last Week",
                        value: "LAST_WEEK",
                      },
                      {
                        label: lang.thisMonth,
                        value: "THIS_MONTH",
                      },
                      {
                        label: "Last Month",
                        value: "LAST_MONTH",
                      },
                      {
                        label: "Last 30 Days",
                        value: "LAST_30_DAYS",
                      },
                      {
                        label: "Custom",
                        value: CUSTOM,
                      },
                    ]}
                    placeholder="Select Date Range"
                  />
                  {dateType === CUSTOM && (
                    <DatePicker.RangePicker
                      className="w-full"
                      size="medium"
                      allowClear={false}
                      value={
                        customRange?.startDate && customRange?.endDate
                          ? [dayjs(customRange.startDate), dayjs(customRange.endDate)]
                          : null
                      }
                      onChange={dates => {
                        if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
                          return;
                        }
                        dispatch(
                          reducerSetAppointmentCustomRange({
                            startDate: dates[0].format(DATE_TIME_FORMATS.YYYY_MM_DD),
                            endDate: dates[1].format(DATE_TIME_FORMATS.YYYY_MM_DD),
                          })
                        );
                      }}
                    />
                  )}
                </div>
              </div>

              {/* Status Filter */}
              <div className="flex flex-col justify-start h-full">
                <div className="flex flex-col gap-1">
                  <label className="text-xs font-medium text-gray-700">Status</label>
                  <Select
                    mode="multiple"
                    size="medium"
                    className="w-full"
                    placeholder="Select Status"
                    // Dedup defensively — if a dashboard drill-in (or any
                    // upstream dispatcher) pushes the same status twice into
                    // redux, AntD would render two chips with the same key
                    // and React logs a duplicate-key warning. The slice
                    // doesn't dedup on writes, so we dedup at the boundary.
                    value={Array.from(new Set(appointmentStatus || []))}
                    maxTagCount="responsive"
                    onChange={values => {
                      // Dedup before diffing so a stale duplicate doesn't
                      // confuse the add/remove detection below.
                      const dedupedValues = Array.from(new Set(values || []));
                      const dedupedCurrent = Array.from(new Set(appointmentStatus || []));
                      const difference =
                        dedupedCurrent.length > dedupedValues.length
                          ? dedupedCurrent.find(value => !dedupedValues.includes(value))
                          : dedupedValues.find(value => !dedupedCurrent.includes(value));

                      if (difference) {
                        handleFilters(difference);
                      } else {
                        // Handle edge cases (like clearing all values at once)
                        dispatch(reducerSetAppointmentStatus(dedupedValues));
                      }
                    }}
                    options={BADGES.map(category => ({
                      label: (
                        <Tag
                          style={{
                            backgroundColor: category.bgColor,
                            borderColor: category.borderColor,
                            color: category.textColor,
                            marginRight: 4,
                          }}
                        >
                          {category.tag}
                        </Tag>
                      ),
                      value: category.onClickLabel,
                    }))}
                  />
                </div>
              </div>
            </div>
            {/* Action Buttons Section */}
            {/* Invisible label spacer (xl only) keeps buttons aligned with the
                dropdown/input row regardless of whether the RangePicker is
                rendered in the Date column. */}
            <div className="flex flex-col gap-1 w-full xl:w-auto xl:min-w-fit">
              <label
                aria-hidden
                className="hidden xl:block text-xs font-medium invisible select-none"
              >
                &nbsp;
              </label>
              <div className="flex flex-col sm:flex-row justify-start xl:justify-end gap-2 w-full">
                <CustomButton
                  btnText="Download CSV"
                  type="default"
                  handleClick={() => {
                    const parseAppointments = (appointments || []).map(appointment => ({
                      "Customer Name": appointment?.lead?.fullName,
                      "Due Date": convertUtcToLocal(
                        appointment?.startDatetime,
                        "YYYY-MM-DD HH:mm:ss",
                        appointment?.timezone
                      ),
                      Status: capitalize(appointment?.appointmentStatus),
                      "Created By": appointment?.createdBy?.fullName,
                      "Created Date": convertUtcToLocal(
                        appointment?.createdOn,
                        "YYYY-MM-DD HH:mm:ss",
                        appointment?.timezone
                      ),
                      "Assigned To": appointment?.user?.fullName,
                      Summary: appointment?.summary,
                      Description: appointment?.content,
                      "Opportunity Name": appointment?.leadOpportunity?.name,
                      "Vehicle Of Interest": parseVehicle(
                        appointment?.leadOpportunity?.vehiclesOfInterest &&
                          appointment?.leadOpportunity?.vehiclesOfInterest.length > 0
                          ? appointment?.leadOpportunity?.vehiclesOfInterest[0]
                          : {}
                      ),
                      "Customer Phone Number":
                        (appointment?.lead?.phoneNumbers &&
                          appointment?.lead?.phoneNumbers.length > 0 &&
                          appointment?.lead?.phoneNumbers[0]?.phone) ||
                        "",
                      Source: `${appointment?.lead?.leadSource?.name} ${
                        appointment?.lead?.leadSource?.parentSource
                          ? `/${appointment?.lead?.leadSource?.parentSource}`
                          : ""
                      }`,
                      "Customer Email":
                        (appointment?.lead?.emails?.length > 0 &&
                          appointment?.lead?.emails[0]?.email) ||
                        "",
                      Confirmed: appointment?.isConfirmed ? "Yes" : "No",
                    }));
                    const csv = convertJSONtoCSV(parseAppointments);
                    downloadCSV(csv);
                  }}
                  className="w-full sm:w-auto min-w-[140px]"
                  disabled={appointments.length === 0}
                  icon={<DownloadOutlined />}
                  iconPosition="start"
                />
                {!window.location.href.includes("activity-center") ? (
                  <>
                    <CustomButton
                      btnText="Add Appointment"
                      type="primary"
                      handleClick={() => handleAppointmentDialog("Add Appointment")}
                      className="w-full sm:w-auto min-w-[140px]"
                      disabled={!canSchedule}
                    />
                    {onBackClick && (
                      <CustomButton
                        handleClick={onBackClick}
                        btnText={lang.back}
                        className="w-full sm:w-auto min-w-[140px]"
                      />
                    )}
                  </>
                ) : (
                  <CustomButton
                    btnText="Add Appointment"
                    type="primary"
                    handleClick={() => onSelectDate(dayjs(), dayjs().add(1, "hour"))}
                    className="w-full sm:w-auto min-w-[140px]"
                    disabled={!canSchedule}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {showDashboardNote && (
        <Row gutter={[4, 24]} className="mb-2 shrink-0">
          <Col span={24}>
            <Alert
              className="w-[98%] mx-auto"
              type="info"
              showIcon
              closable
              message={DASHBOARD_DRILL_IN_NOTE}
            />
          </Col>
        </Row>
      )}

      <Row gutter={[4, 24]} className={fitToViewport ? "lg:flex-1 lg:min-h-0" : undefined}>
        <Col
          sm={24}
          md={24}
          lg={pagePath.includes("browser-ext") ? 17 : 18}
          xl={pagePath.includes("browser-ext") ? 17 : 18}
          className={fitToViewport ? "lg:h-full lg:min-h-0 lg:overflow-y-auto" : undefined}
        >
          {" "}
          {/* <Calendar
              dateCellRender={dateCellRender}
              onSelect={date => {
                (sessionStorage.getItem("currentLocationId") || "").includes(",")
                  ? message.info(lang.selectLocationFromDropdown)
                  : onSelectDate(date);
              }}
              onPanelChange={e => {
                panelChangeDate = dayjs(e);
                onPanelChange(e);
              }}
              data={userList}
              width="20%"
              disabled
            /> */}
          <Spin spinning={loader} tip={`${lang.loading}...`}>
            {shouldRenderComponent && (
              <div className="mb-[30px] px-4 py-6 border-[1px] border-solid rounded-[2px] border-grey-200">
                <FullCalendar
                  key={
                    isCustomRangeMode && hasCustomRangeDates
                      ? `custom-${customRange.startDate}-${customRange.endDate}`
                      : "default"
                  }
                  headerToolbar={{
                    // In custom list mode (>31 days) the title already spans the full
                    // picked range and validRange blocks meaningful navigation, so the
                    // prev/next buttons are useless — show only the title.
                    start: isCustomRangeMode && !customRangeUsesGrid ? "title" : "prev,next title",
                    center: "",
                    // Custom + grid-eligible (≤31 days) keeps the month/week/day toggle so
                    // users can drill in; custom + long range hides the toggle (list view).
                    end:
                      isCustomRangeMode && !customRangeUsesGrid
                        ? ""
                        : "dayGridMonth,timeGridWeek,timeGridDay",
                  }}
                  datesSet={dates => handleDatesSet(dates)}
                  plugins={[dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin]}
                  initialView={
                    isCustomRangeMode && hasCustomRangeDates
                      ? customRangeUsesGrid
                        ? "dayGridMonth"
                        : "appointmentCustom"
                      : STANDARD_CALENDAR_VIEWS.includes(calendarMode)
                      ? calendarMode
                      : "dayGridMonth"
                  }
                  initialDate={calendarInitialDate}
                  views={{
                    // Only used for long custom ranges (>31 days) — efficient list render
                    // for multi-month / cross-year without day-grid pagination.
                    appointmentCustom: {
                      type: "list",
                      buttonText: "Custom Range",
                      visibleRange:
                        isCustomRangeMode && hasCustomRangeDates && !customRangeUsesGrid
                          ? {
                              start: customRange.startDate,
                              // visibleRange end is exclusive in FullCalendar, so add a day.
                              end: dayjs(customRange.endDate).add(1, "day").format("YYYY-MM-DD"),
                            }
                          : undefined,
                    },
                  }}
                  validRange={
                    isCustomRangeMode && hasCustomRangeDates
                      ? {
                          start: customRange.startDate,
                          end: dayjs(customRange.endDate).add(1, "day").format("YYYY-MM-DD"),
                        }
                      : undefined
                  }
                  selectable={!isCustomRangeMode}
                  events={appointments.map(item => ({
                    ...item,
                    date: dayjs
                      ?.utc(item?.startDatetime)
                      ?.tz(item?.timezone || dayjs.tz.guess())
                      .toISOString(),
                    appointmentId: item.id,
                  }))}
                  ref={calendarRef}
                  eventContent={info => renderAppointment(info.event.extendedProps)}
                  select={args => {
                    (sessionStorage.getItem("currentLocationId") || "").includes(",")
                      ? message.info(lang.selectLocationFromDropdown)
                      : onSelectDate(dayjs(args.start), dayjs(args.end));
                  }}
                  moreLinkContent={arg => {
                    return (
                      <div className="w-full flex justify-center mt-3">
                        <div className="cursor-pointer text-[#1677FF] font-medium text-xs">
                          +{arg.num} Appointments
                        </div>
                      </div>
                    );
                  }}
                  dayMaxEvents={MAX_VISIBLE}
                />
              </div>
            )}
          </Spin>
        </Col>
        <Col
          sm={24}
          md={24}
          lg={pagePath.includes("browser-ext") ? 7 : 6}
          xl={pagePath.includes("browser-ext") ? 7 : 6}
          className={fitToViewport ? "lg:h-full lg:flex lg:flex-col lg:min-h-0" : undefined}
        >
          {!isEmpty(lead) && (
            <Alert
              showIcon
              message={
                <>
                  Showing appointments for lead <strong>{lead.fullName}</strong>
                </>
              }
            />
          )}
          <div className="p-[1em] flex items-center justify-between border-solid border-t-0 border-l-0 border-r-0 border-b-[#e8e8e8] shrink-0">
            <Search
              onChange={e => setSearch(e.target.value)}
              // onSearch={e => setSearch(e)}
              placeholder={lang.searchAppointment}
              allowClear
              value={search}
            />
          </div>
          <div
            className={`p-2 overflow-y-auto appointmentList overflow-x-hidden hide-scroll ${
              pagePath.includes("browser-ext") ? "max-h-[calc(100vh-260px)]" : "max-h-[115vh]"
            } ${fitToViewport ? "lg:max-h-none lg:flex-1 lg:min-h-0" : ""}`}
          >
            <Spin spinning={loader}>
              <AppointmentList
                filters={filters}
                searchKey={search}
                leadOpportunities={leadOpportunities}
                canView={canView}
                lead={lead}
                leadId={lead && +lead?.id}
                refreshLeadListData={refreshLeadListData}
              />
            </Spin>
          </div>
        </Col>
      </Row>
      <style jsx>{`
        .appointmentList::-webkit-scrollbar {
          width: 7px;
          background-color: #f1f1f1;
        }

        .appointmentList::-webkit-scrollbar-track {
          -webkit-box-shadow: inset 0 0 0px grey;
          border-radius: 3px;
        }

        .appointmentList::-webkit-scrollbar-thumb {
          border-radius: 3px;
          -webkit-box-shadow: inset 0 0 6px grey;
          background-color: #fcfcfc;
        }

        .fc-daygrid-day-bottom {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      `}</style>
    </Container>
  );
};

export default Appointments;

const PopoverContent = ({ item, vehicles }) => {
  const [lang] = useLang();
  const { user } = useContext(UserContext);
  const location = item => {
    const obj = user?.locations?.find(location => +location?.location?.id === +item.locationId);
    if (obj?.location?.title) {
      return <p>{obj?.location?.title}</p>;
    }
    return "";
  };
  const {
    data: appointmentData,
    loading: appointmentLoader,
    error: appointmentError,
  } = useQuery(GET_APPOINTMENT_POPUP_DETAILS, {
    variables: {
      appointmentId: +item.appointmentId,
    },
    skip: !item.appointmentId,
    fetchPolicy: "network-only",
  });

  const details = appointmentData?.getAppointmentDetails;

  try {
    return (
      <Skeleton
        className="max-w-[350px]"
        active
        loading={appointmentLoader}
        paragraph={{ rows: 3 }}
        avatar
      >
        <div>
          <p className="mb-1">
            {lang.leadName}:{" "}
            <span className="font-medium">
              {details?.lead?.fullName || item?.lead?.fullName || ""}
            </span>
          </p>
          <p className="mb-1">
            {lang.phone}:{" "}
            <span className="font-medium">
              {details?.lead?.phoneNumbers?.[0]?.phone
                ? formatPhoneNumber(details?.lead?.phoneNumbers[0]?.phone)
                : item?.lead?.phoneNumbers
                ? formatPhoneNumber(item?.lead?.phoneNumbers[0]?.phone) || "N/A"
                : "N/A"}
            </span>
          </p>
          <p className="mb-1">
            {lang.emailLabel}:{" "}
            <span className="font-medium">
              {details?.lead?.emails?.[0]?.email || item?.lead?.emails?.[0]?.email || "N/A"}
            </span>
          </p>
          <p className="mb-1">
            {lang.source}:{" "}
            <span className="font-medium">
              {details?.lead?.leadSource?.name || item?.lead?.leadSource?.name || ""}
            </span>
          </p>
          <div className="flex flex-row gap-1">
            <p>Appointment Status: </p>
            <b>{firstUpperCaseWordParser(item.appointmentStatus)}</b>
          </div>

          {(details?.leadOpportunity?.name || item?.leadOpportunity?.name) && (
            <p className="mb-1">
              {lang.opportunity}:{" "}
              <span className="font-medium">
                {" "}
                <Tooltip placement="topLeft" title={lang.opportunity}>
                  <Tag color="green">
                    {details?.leadOpportunity?.name || item?.leadOpportunity?.name}
                  </Tag>
                </Tooltip>
              </span>
            </p>
          )}
          {(details?.user?.fullName || item?.user?.fullName) && (
            <div className="flex mb-1 items-center gap-1">
              <p>{lang.assignedTo}: &nbsp;</p>
              <p className="font-medium">{`${details?.user?.fullName || item?.user?.fullName} (${
                details?.user?.companyRole?.name || item?.user?.companyRole?.name || "N/A"
              })`}</p>
            </div>
          )}
          {details?.locationId && (
            <div className="flex mb-1 items-center gap-1">
              <p>{lang.location}: </p>
              <p className="font-medium">{location(appointmentData?.getAppointmentDetails)}</p>
            </div>
          )}
          <p>
            {lang.vehicles}:{" "}
            {(details?.leadOpportunity?.vehiclesOfInterest || []).length > 0
              ? vehicles(getUniqueVehicleOfInterest(details?.leadOpportunity?.vehiclesOfInterest))
              : vehicles(
                  getUniqueVehicleOfInterest(item?.leadOpportunity?.vehiclesOfInterest || [])
                )}
          </p>
          {details?.dateCreated && (
            <p className="mb-1">
              Created:{" "}
              <span className="font-medium">
                {convertUtcToLocal(
                  details?.dateCreated,
                  DATE_TIME_FORMATS.DD_MMM_YYYY_hh_mm_A,
                  details?.timezone
                )}
              </span>
            </p>
          )}
          {details?.dateUpdated && (
            <p className="mb-1">
              Updated:{" "}
              <span className="font-medium">
                {convertUtcToLocal(
                  details?.dateUpdated,
                  DATE_TIME_FORMATS.DD_MMM_YYYY_hh_mm_A,
                  details?.timezone
                )}
              </span>
            </p>
          )}
        </div>
      </Skeleton>
    );
  } catch (err) {
    console.log(err);
  }
};
